import { render } from "./About.vue?vue&type=template&id=1ae8a7be"
const script = {}
script.render = render

export default script